import React, { useEffect, useState } from 'react'
import format from 'date-fns/format'
import { get, patch, post } from 'aws-amplify/api'
import { useAuth0 } from '@auth0/auth0-react'
import { useNavigate } from 'react-router-dom'
import ParametersContext from '../context/ParametersContext'

const ParametersProvider = ({ children }) => {
  const { getIdTokenClaims } = useAuth0()
  const [tokenAuth, setTokenAuth] = useState('')
  const [data, setData] = useState(null)
  const [showLoader, setShowLoader] = useState(true)
  const [formResults, setFormResults] = useState({})
  const [showMessage, setShowMessage] = useState(false)
  const [typeMessage, setTypeMessage] = useState('')
  const [isDisabled, setIsDisabled] = useState(true)
  const [enabledButton, setEnabledButton] = useState(true)
  const [verifiedDueDate, setVerifiedDueDate] = useState(false)
  const [verifiedCalculatedData, setVerifiedCalculatedData] = useState(false)

  const navigate = useNavigate()
  const baseUrl = process.env.REACT_APP_API_BASE_URL

  useEffect(() => {
    getIdTokenClaims()
      .then((resp) => {
        if (resp !== undefined) {
          setTokenAuth(resp)
        }
      })
      .catch((error) => console.log(error))
  }, [getIdTokenClaims])

  useEffect(() => {
    setShowLoader(true)
    if (tokenAuth !== '') {
      const fetchData = async () => {
        try {
          const resp = get({
            apiName: baseUrl,
            path: '/api/v2/pregnancies/information',
            options: {
              headers: {
                'content-type': 'application/json',
                Authorization: `Bearer ${tokenAuth.__raw}`
              }
            }
          })
          const { body } = await resp.response
          const data = await body.json()
          setData(data.data)
        } catch (error) {
          console.log(error)
        }
      }
      fetchData()
    }
  }, [tokenAuth, baseUrl])

  const saveDataParameters = async () => {
    setShowLoader(true);
    const {
      dueDate,
      estimatedBirthDate,
      gestationalDay,
      gestationalWeek,
      lastMenstruationDate,
      newbornsNumber,
    } = formResults;

    const body = {
      gestational_week:
        gestationalWeek.length > 2
          ? gestationalWeek.split(" ")[0]
          : gestationalWeek,
      gestational_day:
        gestationalDay.length > 2
          ? gestationalDay.split(' ')[0]
          : gestationalDay,
      estimated_birth_date: format(new Date(estimatedBirthDate), 'MM/dd/YYY'),
      last_menstruation: format(new Date(lastMenstruationDate), 'MM/dd/YYY'),
      due_date: dueDate ? format(new Date(dueDate), 'MM/dd/YYY') : '',
      newborns_number: newbornsNumber
    }

    if (dueDate === -1) {
      delete body.due_date
    }

    try {
      const resp = patch({
        apiName: baseUrl,
        path: '/api/v2/pregnancies/information',
        options: {
          headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${tokenAuth.__raw}`
          },
          body
        }
      })
      const { body: responseBody } = await resp.response
      const data = await responseBody.json()

      if (data.success) {
        setShowLoader(false)
        setTypeMessage('success')
        setShowMessage(true)
        setIsDisabled(true)
        setEnabledButton(true)
        setTimeout(() => {
          setShowMessage(false)
        }, 3000)
      }
    } catch (error) {
      console.log(error)
    }
  };

  const dontSaveDataParameters = () => {
    setShowMessage(false)
    setIsDisabled(true)
    setEnabledButton(true)
  }

  const updateGrief = async () => {
    try {
      const resp = post({
        apiName: baseUrl,
        path: '/auth/grief',
        options: {
          headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${tokenAuth.__raw}`
          },
          body: {
            grief: true
          }
        }
      })
      await resp.response
      navigate('/perdida')
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <ParametersContext.Provider
      value={{
        data,
        showLoader,
        setShowLoader,
        formResults,
        setFormResults,
        saveDataParameters,
        dontSaveDataParameters,
        isDisabled,
        setIsDisabled,
        enabledButton,
        setEnabledButton,
        showMessage,
        setShowMessage,
        typeMessage,
        setTypeMessage,
        verifiedDueDate,
        setVerifiedDueDate,
        verifiedCalculatedData,
        setVerifiedCalculatedData,
        updateGrief
      }}
    >
      {children}
    </ParametersContext.Provider>
  )
}

export default ParametersProvider
